import I18n from "common/i18n";
import { ChatInputBar } from "common/elements";

interface ChatInputProps {
  onSend: (message: string, imageUrls?: string[]) => void;
  onStop?: () => void;
  isTyping?: boolean;
  disabled?: boolean;
}

export const ChatInput = ({
  onSend,
  onStop,
  isTyping = false,
  disabled = false,
}: ChatInputProps) => {
  // ChatInputBarのonSendはimageUrl（単数）を受け取るので、imageUrls（配列）に変換
  const handleSend = (message: string, imageUrl?: string) => {
    const imageUrls = imageUrl ? [imageUrl] : undefined;
    onSend(message, imageUrls);
  };

  return (
    <ChatInputBar
      onSend={handleSend}
      onStop={onStop}
      isTyping={isTyping}
      combineImageAndText
      showCaptureButton
      disabled={disabled}
      placeholder={I18n.t("MSG_ASSISTANT_PLACEHOLDER")}
    />
  );
};
